import AppLayout from "layouts/appLayout/AppLayout";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BlogPost, Button, Card, Link } from "stories";
import classes from "./Dashboard.module.scss";

const Dashboard = () => {
  return (
    <AppLayout title={"Dashboard"}>
      <Helmet>
        <title>Dashboard | Fundever</title>
      </Helmet>
      <div className={`${classes["dashboard-main-container"]}`}>
        <Row>
          <Col xs={7}>
            <div className={"section-title"}>Unread Messages</div>
            <Card noShadow heightAuto>
              <div className={`${classes["card-content"]}`}>
                <div className={`${classes["card-title"]}`}>
                  You have no messages
                </div>
                <div className={"w-50 my-3"}>
                  <Link to={"/profile"}>
                    <Button label={"Setup Profile"} />
                  </Link>
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={5}>
            <div className={"section-title"}>Activities and Notifications</div>
            <Card noShadow heightAuto>
              <div className={`${classes["card-content"]}`}>
                <div className={`${classes["card-title"]}`}>Nothing here</div>
              </div>
            </Card>
          </Col>
        </Row>
        <Row>
          <section className={`${classes["blog-section"]}`}>
            <Col>
              <div className={"section-title"}>Market Updates</div>
              <Row className={`${classes["blog-post-wrapper"]}`}>
                <BlogPost
                  image={"https://picsum.photos/300/200?grayscale"}
                  title={"Title"}
                  subtitle={
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus, aliquid earum esse et facere ipsum maiores."
                  }
                  link={""}
                />
                <BlogPost
                  image={"https://picsum.photos/300/200?grayscale"}
                  title={"Title"}
                  subtitle={
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus, aliquid earum esse et facere ipsum maiores."
                  }
                  link={""}
                />
              </Row>
            </Col>
          </section>
        </Row>
      </div>
    </AppLayout>
  );
};

export default Dashboard;
